export default "/static/media/icon-close.3bdc852c.svg";